import ManageColumnsList from './ManageColumnsList.component';

export default ManageColumnsList;
